import React from 'react';
import { Lock, ShieldCheck } from 'lucide-react';
interface CTAButtonProps {
  text: string;
  href?: string;
  onClick?: () => void;
  variant?: 'primary' | 'urgency';
  className?: string;
  showTrust?: boolean;
}
export function CTAButton({
  text,
  href,
  onClick,
  variant = 'primary',
  className = '',
  showTrust = true
}: CTAButtonProps) {
  const baseClasses = 'relative w-full flex flex-col items-center justify-center min-h-[64px] px-6 py-4 rounded-xl font-bold text-lg md:text-xl transition-all duration-300 overflow-hidden group';
  const primaryClasses = 'bg-forest text-gold shadow-forest hover:bg-forest-light hover:-translate-y-1 animate-pulse-soft';
  const urgencyClasses = 'bg-urgency text-white shadow-lg hover:bg-urgency-light hover:-translate-y-1 animate-pulse-urgency';
  const buttonClasses = `${baseClasses} ${variant === 'primary' ? primaryClasses : urgencyClasses} ${className}`;
  const handleAnchorClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    if (href && href.startsWith('#')) {
      e.preventDefault();
      const target = href === '#offer-section' ? '#offer-stack' : href;
      const element = document.querySelector(target);
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth'
        });
      }
    }
    onClick?.();
  };
  const isAnchorLink = href?.startsWith('#');
  const content = <>
      {/* Shine effect — pointer-events-none so it never blocks clicks */}
      <div className="absolute inset-0 -translate-x-full group-hover:animate-[shimmer_1.5s_infinite] bg-gradient-to-r from-transparent via-white/20 to-transparent skew-x-12 pointer-events-none" data-id="element-63"></div>

      <span className="relative z-10 flex items-center text-center leading-tight text-[#FBFBFA] pointer-events-none" data-id="element-64">
        {text}
      </span>
    </>;
  return <div className="w-full flex flex-col items-center" data-id="element-65">
      {href ? isAnchorLink ? <a href={href} onClick={handleAnchorClick} className={buttonClasses} data-id="element-66">
            {content}
          </a> : <a href={href} target="_blank" rel="noopener noreferrer" className={buttonClasses} data-id="element-67">
            {content}
          </a> : <button onClick={onClick} className={buttonClasses} data-id="element-68">
          {content}
        </button>}

      {showTrust && <div className="flex items-center justify-center gap-4 mt-3 text-xs md:text-sm text-dark/70 font-medium" data-id="element-69">
          <div className="flex items-center gap-1" data-id="element-70">
            <ShieldCheck size={14} className="text-forest" data-id="element-71" />
            <span data-id="element-72">Garantía 30 Días</span>
          </div>
        </div>}
    </div>;
}